(function () {
  "use strict";

  function bindStory(section) {
    if (!section || section.dataset.nayaStoryBound === "true") return;
    section.dataset.nayaStoryBound = "true";

    var btn = section.querySelector("[data-story-toggle]");
    var content = section.querySelector("[data-story-content]");
    var inner = section.querySelector(".naya-story__content-inner");

    if (!btn || !content || !inner) return;

    var labelOpen = btn.getAttribute("data-label-open") || "Learn more +";
    var labelClose = btn.getAttribute("data-label-close") || "Show less −";

    function collapse() {
      section.classList.remove("is-expanded");
      btn.setAttribute("aria-expanded", "false");
      btn.textContent = labelOpen;
      content.style.overflow = "hidden";
      content.style.maxHeight = "0px";
    }

    function expand() {
      section.classList.add("is-expanded");
      btn.setAttribute("aria-expanded", "true");
      btn.textContent = labelClose;
      content.style.overflow = "hidden";
      content.style.maxHeight = inner.scrollHeight + "px";
    }

    // start collapsed
    collapse();

    btn.addEventListener("click", function () {
      var expanded = btn.getAttribute("aria-expanded") === "true";
      if (expanded) collapse();
      else expand();
    });

    window.addEventListener("resize", function () {
      if (btn.getAttribute("aria-expanded") === "true") {
        content.style.maxHeight = inner.scrollHeight + "px";
      }
    });
  }

  function initAll() {
    document.querySelectorAll("[data-naya-story]").forEach(bindStory);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("page:loaded", initAll);
})();